import { theme } from '@theme';

export const navbarMenuItemTitle = (open: boolean, isLoginPage: boolean) => ({
  height: '48px',
  color: theme.palette.common.primaryDark,
  fontSize: '16px',
  fontWeight: 600,
  background: !isLoginPage && open ? theme.palette.common.darkGrey0 : 'unset',
  '&:hover': {
    background: 'unset'
  }
});

export const navbarMenuItemContent = {
  '.MuiPaper-root': {
    border: `1px solid ${theme.palette.common.darkGrey0}`,
    borderRadius: '12px',
    padding: '8px',
    top: '83px !important'
  }
};

export const navbarMenuItemElement = {
  padding: '16px',
  borderRadius: '4px',
  '&:hover': {
    background: theme.palette.common.monochrome15
  }
};

export const navbarMenuItemMobileText = {
  '.MuiTypography-root': {
    fontWeight: 600,
    color: theme.palette.common.primaryDark
  }
};

export const navbarMenuItemTitleTextBox = {
  fontWeight: 600,
  color: theme.palette.common.primaryDark,
  overflowWrap: 'break-word'
};

export const navbarMenuSubItemTypography = {
  noWrap: false,
  sx: {
    maxWidth: 180,
    whiteSpace: 'normal',
    wordBreak: 'break-word'
  }
};

export const navbarMenuItemButton = {
  paddingTop: '12px',
  paddingBottom: '12px',
  display: 'flex',
  gap: '8px',
  alignItems: 'center'
};

export const navbarMenuArrowIcon = {
  color: 'inherit',
  display: 'inline-flex',
  '& svg path': { fill: 'currentColor' }
};
